import { array, number, boolean, defineAction, object, string, enumerated } from '~/prix'
import legalEntityMassGeocodeAction from './legalEntityMassGeocode.action.json'

const legalEntityMassGeocodeDefinition = defineAction({
  ...legalEntityMassGeocodeAction,
  input: object({
    concurrency: number().label('Quantidade de municípios processados de forma concorrente.'),
    addressConcurrency: number()
      .isOptional()
      .label('Quantidade de endereços geocodificados simultaneamente por município.'),
    level: enumerated({
      macroRegion: 'macroRegion',
      mesoRegion: 'mesoRegion',
      microRegion: 'microRegion',
      state: 'state',
      city: 'city',
    }).isOptional(),
    ibgeCodes: string(),
    force: boolean()
      .isOptional()
      .label(
        'Geocodificar todos os endereços na legal_entity e não somente os nulos ou desatualizados.',
      ),
    ensureGeocodingVersion: boolean()
      .isOptional()
      .label('Geocodificar onde a versão do geocoding for diferente da mais atual.'),
    rejectedOnly: boolean()
      .isOptional()
      .label(
        'Reprocessar somente endereços sem correspondência ou ajustados pela segurança espacial, sem agendar exportação.',
      ),
    debug: boolean().isOptional(),
    geocodeWhere: string().isOptional(),
    uniqueKey: string().isOptional(),
    chunkSize: string().isOptional(),
  }),
  output: object({}),
})

export default legalEntityMassGeocodeDefinition
